<template>
    <v-container fluid>
        <v-card>
            <v-toolbar color="secondary" flat dense>
                <v-toolbar-title>Stock Movement Analysis</v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
                <v-row>
                    <v-col cols="12" xs="12" sm="12" md="3">
                        <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40"
                            transition="scale-transition" offset-y min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field dense outlined single-line v-model="StartDate" label="From"
                                    prepend-icon="mdi-calendar-month" v-on="on" readonly></v-text-field>
                            </template>
                            <v-date-picker v-model="StartDate" @input="menu1 = false"></v-date-picker>
                        </v-menu>
                    </v-col>

                    <!-- datepicker 2 -->
                    <v-col cols="12" xs="12" sm="12" md="3">
                        <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40"
                            transition="scale-transition" offset-y min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field dense outlined single-line v-model="EndDate" label="To"
                                    prepend-icon="mdi-calendar-month" v-on="on" readonly></v-text-field>
                            </template>
                            <v-date-picker v-model="EndDate" @input="menu2 = false"></v-date-picker>
                        </v-menu>
                    </v-col>

                    <v-col cols="12" xs="12" md="3">
                        <v-autocomplete dense outlined v-model="queryStore" :items="stores" label="Select Branch / Shop"
                            item-text="Name" item-value="id"></v-autocomplete>
                    </v-col>

                    <v-col cols="3">
                        <v-btn color="primary" @click="getRecords" :loading="loader">Query Data</v-btn>
                    </v-col>

                </v-row>
                <v-row class="subtitle-2 text--primary">
                    <v-col cols="12" md="6">
                        <!-- excel icon -->
                        <download-excel :data="auditData" :fields="fields" name="Stock Analysis List">
                            <v-icon color="green">mdi-file-excel</v-icon>
                        </download-excel>
                        <!-- end -->
                    </v-col>

                    <v-col cols="12" md="6">

                        <!-- excel icon -->
                        <download-excel :data="auditData" :fields="closingFields" name="Opening Closing valuation">
                            Opening / Closing Valuation <v-icon color="green">mdi-file-excel</v-icon>
                        </download-excel>
                        <!-- end -->
                    </v-col>

                    <v-col cols="12">
                        <v-text-field v-model="search" label="Search" outlined dense></v-text-field>
                        <!-- start of table -->
                        <v-data-table :items-per-page="pageItems" :headers="headers" :items="auditData"
                            :search="search">
                            <template v-slot:item.action="{ item }">
                                <v-btn color="accent" text :to="`/stock-transfer/${item.id}`" icon>
                                    <v-icon>mdi-eye</v-icon>
                                </v-btn>
                            </template>

                            <template v-slot:item.date="{ item }">
                                {{ item.date | date }}
                            </template>

                            <template v-slot:item.received="{ item }">
                                <span style="color: green; font-weight: bold"
                                    v-if="item.received == 'Y'">Received</span>
                                <span style="color: red; font-weight: bold" v-if="item.received == 'N'">Not Received
                                    Yet</span>
                            </template>
                        </v-data-table>
                        <!-- end -->
                    </v-col>
                </v-row>

                <!-- pdf preview -->
                <pdf-preview ref="pdfPreview"></pdf-preview>
                <!-- snackbar -->
            </v-card-text>
        </v-card>

        <snackbar ref="snackbar"></snackbar>
    </v-container>
</template>

<script>
import { generatePdf } from "@/common/transferMethods.js";
export default {
    data() {
        return {
            queryStore: null,
            search: null,
            pageItems: 100,
            menu1: false,
            menu2: false,
            StartDate: null,
            EndDate: null,
            FromStore: null,
            ToStore: null,
            PickedBy: null,
            loader: false,
            stores: [],
            users: [],
            headers: [
                { text: "Product", value: "productName" },
                { text: "Opening Qty", value: "openingQty" },
                { text: "Total Purchases", value: "totalPurchases" },
                { text: "Total Sales", value: "totalSales" },
                { text: "Sale Returns", value: "totalSalesReturns" },
                { text: "Transfer In", value: "totalTransferIn" },
                { text: "Transfer Out", value: "totalTransferOut" },
                { text: "Purchase Returns", value: "totalPurchaseReturns" },
                { text: "Closing Qty", value: "closingQty" },
            ],
            fields: {
                Product: "productName",
                OpeningQty: "openingQty",
                TotalPurchases: "totalPurchases",
                TotalSales: "totalSales",
                SaleReturns: "totalSalesReturns",
                TransferIn: "totalTransferIn",
                TransferOut: "totalTransferOut",
                PurchaseReturns: "totalPurchaseReturns",
                ClosingQty: "closingQty",
            },
            closingFields: {
                Product: "productName",
                OpeningQty: "openingQty",
                BuyingPrice: "buyingPrice",
                OpeningStockValue: "totalOpeningValue",
                ClosingQty: "closingQty",
                ClosingBuyingPrice: "buyingPrice",
                ClosingStockValue: "totalClosingValue",
            },
            auditData: [],
        };
    },
    computed: {
        totalSalesValue() {
            let total = 0;
            if (this.totalSales) {
                total = this.totalSales.toLocaleString();
            }
            return total;
        },
        totalAmount() {
            let total = 0;
            if (
                typeof this.stockTransfers != "undefined" &&
                this.stockTransfers.length > 0
            ) {
                return this.stockTransfers
                    .map((item) => {
                        const amount = item.Quantity * item.BuyingPrice;
                        total = +amount;
                        return total;
                    })
                    .reduce((val, a) => {
                        return val + a;
                    });
            } else {
                return total;
            }
        },
    },
    methods: {
        generatePdf,
        getRecords() {
            const self = this;
            var subscriberId = parseInt(localStorage.getItem("subscriber_id"));
            const data = {
                StartDate: self.StartDate,
                EndDate: self.EndDate,
                StoreId: parseInt(self.queryStore),
                SubscriberId: subscriberId
            };

            self.loader = true;
            const url = `/stock-movement-analysis`;
            this.$store
                .dispatch("post", { url, data })
                .then((res) => {
                    if (res.ResultCode == 1200) {
                        self.loader = false;
                        self.auditData = res.ResponseData;
                    } else {
                        self.loader = false;
                        this.$refs.snackbar.show(res.msg, "red");
                    }
                })
                .catch((err) => {
                    self.loader = false;
                    this.$refs.snackbar.show(err, "red");
                });
        },
        getStores() {
            const self = this;
            this.$store
                .dispatch("get", `/stores`)
                .then((res) => {
                    if (res.ResultCode == 1200) {
                        self.stores = res.ResponseData;
                    } else {
                        this.$refs.snackbar.show(res.msg, "red");
                    }
                })
                .catch((err) => {
                    this.$refs.snackbar.show(err, "red");
                });
        },
        printDoc() {
            if (this.StartDate == null || this.EndDate == null) {
                this.$refs.snackbar.show("Please select both dates", "red");
            } else {
                const self = this;
                const pdfDoc = this.generatePdf(
                    self.StartDate,
                    self.EndDate,
                    self.stockTransfers
                );

                this.$refs.pdfPreview.show(pdfDoc);
            }
        },
    },
    created() {
        Promise.all([this.getStores()]);
    },
};
</script>

<style lang="scss" scoped></style>